<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-card
            v-bind="attrs"
            v-on="on"
            :color="ruleColor"
            elevation="0"
            rounded
            class="a-card-pricing-strategy-strategy-rule-mini mx-auto"
            @click="showRuleInfoDialog(suggestion)"
          >
            <v-card-text class="pa-2">
              <div
                class="d-flex align-center justify-center"
                style="gap: 4px;"
                :style="
                  `font-size: 11px; line-height: 1; color: ${ruleColorText}`
                "
              >
                <!-- Un guardarail no se distingue de una regla por el nombre:
                     el escudo es el mismo del bloque de guardarailes. -->
                <v-icon
                  v-if="isGuardrail"
                  size="12"
                  :color="ruleColorText"
                  class="flex-shrink-0"
                >
                  mdi-shield-outline
                </v-icon>
                <span class="font-weight-medium text-truncate">
                  {{ rule.name }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </template>
      <span>{{ isGuardrail ? $t("View_guardrail") : $t("View_rule") }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import * as Utils from "@/utils.js";

export default {
  name: "a-pricing-strategy-card-strategy-rule-mini",
  props: {
    rule: {
      type: Object,
      required: true
    },
    suggestion: {
      type: Object,
      required: true
    }
  },
  computed: {
    rule_definition_info_dialog: {
      get() {
        return this.$store.state.pricingstrategy.rule_definition_info_dialog;
      },
      set(value) {
        this.$store.dispatch(
          "setPricingStrategyRuleDefinitionInfoDialog",
          value
        );
      }
    },
    rule_info: {
      get() {
        return this.$store.state.pricingstrategy.rule_info;
      },
      set(value) {
        this.$store.dispatch("setPricingStrategyRuleInfo", value);
      }
    },
    // Un guardarail no tiene horario propio: se evalúa tras cada cálculo. Es
    // lo que lo distingue de una regla sin tener que buscarlo en ningún sitio,
    // y funciona también con el fijo de mín/máx, que no está en ningún dataset.
    isGuardrail() {
      const rule = this.rule || {};
      if (rule.rule_kind) return rule.rule_kind === "guardrail";
      return !!(rule.schedule && rule.schedule.frequency === "on_change");
    },
    ruleColor() {
      return this.rule.color;
    },
    ruleColorText() {
      return Utils.intensifyColor(this.ruleColor);
    }
  },
  methods: {
    showRuleInfoDialog(suggestion) {
      this.rule_info = suggestion;
      this.rule_definition_info_dialog = true;
    }
  }
};
</script>

<style scoped lang="scss">
.a-card-pricing-strategy-strategy-rule-mini {
  // Ancho contenido dentro de la celda de la tabla (white-space: nowrap):
  // sin límite, un nombre largo estiraría la columna sin truncarse
  max-width: 200px;
  min-width: 120px;
}
</style>
